import React, { useState, useEffect, useContext, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { RiContactsLine } from 'react-icons/ri';
import { ModalCtx } from '../../../contexts';
import SendTxt from '../../Modals/SendTxt';
import SendEmail from '../../Modals/SendEmail';
import { MdContentCopy } from 'react-icons/md';

import './compactview.css';


const CompactView = ( { e, layout } ) => {
    const { openModal, closeModal, setModal } = useContext( ModalCtx );
    
    const [ hasButtons, setHasButtons ] = useState( false );
    const [ hasDropdown, setHasDropdown ] = useState( false );
    const [ hasFields, setHasFields ] = useState( false );
    
    useEffect( () => {
        if ( layout?.buttons?.length ) {
            setHasButtons( true );
        }
        if ( layout?.dropdown?.length ) {
            setHasDropdown( true );
        }
        if ( layout?.fields?.length ) {
            setHasFields( true );
        }
    }, [ layout ] );

    const handleModal = ( mt, template ) => {
        let shouldOpen = true;

        switch ( mt ) {
            case 'email':
                setModal( <SendEmail close={closeModal} template={template} /> ); 
                break;

            case 'sms':
                setModal( <SendTxt close={closeModal} /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + mt );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const renderDataType = ( field ) => {
        let el = null;

        switch ( field.type ) {
            case 'text':
                el = e[field.db];
                break;

            case 'email':
                el = <Fragment>
                        <a href={`mailto:${e[field.db]}`}>{e[field.db]}</a>
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip id={`tooltip-${field.db}`}>
                                    Copy to clipboard
                                </Tooltip>
                            }
                        >
                            <Button variant='link' className='ms-2 p-0 tf-copy-button' onClick={ () => { navigator.clipboard.writeText( e[field.db] ) } }><MdContentCopy /></Button>
                        </OverlayTrigger>
                    </Fragment>;
                break;

            case 'phone':
                el = <Fragment>
                        <a href={`tel:${e[field.db]}`}>{e[field.db]}</a>
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip id={`tooltip-${field.db}`}>
                                    Copy to clipboard
                                </Tooltip>
                            }
                        >
                            <Button variant='link' className='ms-2 p-0 tf-copy-button' onClick={ () => { navigator.clipboard.writeText( e[field.db] ) } }><MdContentCopy /></Button>
                        </OverlayTrigger>
                    </Fragment>;
                break;

            case 'contact':
                el = e[field.db];
                break;

            default:
                console.log( 'Unknown renderDataType:', field );
                el = e[field.db];
        }

        return el;
    }

    return (
        <Fragment>
            <Container fluid>
                <Row className='tf-contact-cv-name-container py-2 align-items-center'>
                    <Col className='fs-4' xs='auto'>
                        <RiContactsLine />
                        <span className='ps-3 fw-bold'>{e.name}</span>
                    </Col>
                    {
                        hasButtons ? (
                            <Col className='text-end'>
                                <Dropdown as={ButtonGroup}>
                                    {
                                        layout.buttons.map( ( b, idx ) => { 
                                            return <Button key={`contact-cv-button-${idx}`} className='tf-obj-button' size='sm' onClick={ () => handleModal( b.modal, b.template ) }>{b.label}</Button>
                                        } )
                                    }
                                    {
                                        hasDropdown ? (
                                            <Fragment>
                                                <Dropdown.Toggle split className='tf-obj-button' id="dropdown-split-basic" />
                                                <Dropdown.Menu id="dropdown-basic-button">
                                                    {
                                                        layout.dropdown.map( ( d, idx ) => {
                                                            return <Dropdown.Item key={`contact-cv-dropdown-${idx}`} onClick={ () => handleModal( d.modal, d.template ) }>{d.label}</Dropdown.Item>
                                                        })
                                                    }
                                                </Dropdown.Menu>
                                            </Fragment>
                                        ) : (
                                            null
                                        )
                                    }
                                </Dropdown>
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
                {
                    hasFields ? (
                        <Row className='py-2'>
                            {
                                layout.fields.map( ( f, idx ) => {
                                    return (
                                        <Col key={`contact-cv-field-${idx}`} className='col-md-auto'>
                                            <Row><Col className='fs-8'>{f.label}</Col></Row>
                                            <Row><Col className='fs-7 fw-semibold'>{renderDataType( f )}</Col></Row>
                                        </Col>
                                    )
                                } )
                            }
                        </Row>
                    ) : (
                        null
                    )
                }
            </Container>
        </Fragment>
  )
}

const mapProps = ( state ) => ( {
    // e: state.events.current.details,
    // layout: state.user.meta.event.cv
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.contacts.loadContactDetails
} );
  
export default connect( mapProps, mapDispatch )( CompactView );